var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showEventModal,
          expression: "showEventModal",
        },
      ],
      staticClass: "font-c3x6",
      attrs: { id: "event_modal" },
    },
    [
      _c("div", { staticClass: "overlay d-grid" }, [
        _c(
          "div",
          { staticClass: "box gray" },
          [
            _c("div", { staticClass: "box white text-center" }, [
              _c("img", {
                staticStyle: {
                  position: "absolute",
                  top: "-87px",
                  transform: "translateX(-50%)",
                  width: "140px",
                  left: "50%",
                },
                attrs: {
                  src: `${_vm.$s3}/img/common/map/map_event.png?${_vm.$ver}`,
                },
              }),
              _c("div", { staticClass: "font-w700" }, [
                _vm._v("주말 보너스 이벤트"),
              ]),
              _vm._m(0),
              _c("div", { staticClass: "font-s12 font-c6x6 mt-2" }, [
                _vm._v(
                  "\n          * 받은 청약쿠폰은 알림 내역에서 확인하실 수 있습니다.\n        "
                ),
              ]),
              _vm._m(1),
              _c("div", { staticClass: "font-s12 font-c6x6 mt-2" }, [
                _vm._v("(7일, 8일, 14일, 15일 ,21일, 22일, 28일, 29일)"),
              ]),
            ]),
            _c(
              "b-button",
              {
                staticStyle: { "margin-top": "8.5px" },
                attrs: { variant: "primary" },
                on: { click: _vm.hideModal },
              },
              [_vm._v(" 확인 ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "font-s14 mt-3" }, [
      _c("div", [_vm._v("주말에 오픈메타시티에 접속만 해도")]),
      _c("div", { staticClass: "mt-1" }, [
        _vm._v("\n            청약쿠폰\n            "),
        _c(
          "span",
          { staticClass: "font-w600", staticStyle: { color: "#0a57d4" } },
          [_vm._v("10장")]
        ),
        _vm._v("이 추가로 지급됩니다!\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "font-s14 font-c6x6 mt-3" }, [
      _vm._v("\n          기간 :\n          "),
      _c("span", { staticClass: "font-c3x6 font-w700" }, [
        _vm._v("5월의 매주 토요일, 일요일"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }